// Generated by purs version 0.15.15
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var convertDuration = /* #__PURE__ */ Data_Time_Duration.convertDuration(Fusion_Data_Duration.durationDuration)(Data_Time_Duration.durationSeconds);
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonNumber);
var encodeAsSeconds = function () {
    return function (duration) {
        return encodeJson(unwrap(convertDuration(duration)));
    };
};
var encodeAsBps = function () {
    return function ($7) {
        return encodeJson(Fusion_Data_Speed.toBps($7));
    };
};
var decodeAsBps = function () {
    return function (json) {
        return map(Fusion_Data_Speed.fromBps)(decodeJson(json));
    };
};
export {
    decodeAsBps,
    encodeAsBps,
    encodeAsSeconds
};
